export const Text = {
  baseStyle: {
    fontSize: {
      md: '16px',
      lg: '18px',
    },
    color: 'black.50',
  },
};
